export default {
	home: 'home',
	details: 'details',
	checklist: 'checkliste'
}
